export function IconArrow(props: {className?: string}) {
  return (
    <svg
      width="9"
      height="17"
      viewBox="0 0 9 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M8.73816 8.50005L8.14753 7.82192L1.84753 0.471924L0.261613 1.82817L5.98201 8.49987L0.261612 15.1716L1.84753 16.5278L8.14753 9.17782L8.73816 8.50005Z"
        fill="currentColor"
      />
    </svg>
  );
}
